import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { EventDetails } from './EventDetails';
import { EventReservation } from '../events/EventReservation';
import { EventReservationComplete } from '../events/EventReservationComplete';
import { EventReservationError } from '../events/EventReservationError';
import { useEventReservationState } from './states/EventPaneState';
import { RouteComponentProps } from 'react-router-dom';

type Props =
  | {
      eventId: string;
    }
  | RouteComponentProps<{ eventId: string }>;

export const EventPane = observer((props: Props) => {
  const eventId = 'eventId' in props ? props.eventId : props.match?.params.eventId;
  const parsedEventId = Number(eventId);
  if (isNaN(parsedEventId)) return null;
  const { progress, clear } = useEventReservationState(parsedEventId);
  useEffect(() => {
    return () => {
      clear();
    };
  }, []);
  switch (progress) {
    case 'detail':
      return <EventDetails eventId={parsedEventId} />;

    case 'reserve':
      return <EventReservation eventId={parsedEventId} />;

    case 'complete':
      return <EventReservationComplete eventId={parsedEventId} />;

    case 'error':
      return <EventReservationError eventId={parsedEventId} />;
  }
});
